"use strict";
import { siteConfig } from '../siteConfig';

module.exports = ['departments', 'Member', 'Authentication', 'Form', '$translate', '$state', '$uibModal', 'myTenant',
    function (departments, Member, Authentication, Form, $translate, $state, $uibModal, myTenant) {
        var _this = this;
        this.siteConfig = siteConfig;
        this.isCertDigital = siteConfig.tags.includes("certdigital")
        
        _this.allowedTenantIdsForValidations = [
            '6654852498283e97620ff807', // Tenant Technology Bureau
            "56fc21e402a3885f336d8d3f", // Tenant Voolks
            "5f23071cc5643d8a126e5250", // EDENOR
        ];
        
        _this.shouldShowValidations = function() {
            if (siteConfig.tags && siteConfig.tags.includes("certdigital")) {
                return true;
            }
            const currentTenant = myTenant.get();
            if (currentTenant && currentTenant.id) {
                if (_this.allowedTenantIdsForValidations.includes(currentTenant.id)) {
                    return true;
                }
            }
            return false;
        };
        
        this.dateOptions = {
            formatYear: 'yyyy',
            startingDay: 1,
            showWeeks: false
        };
        
        
        _this.filter = {
            fechaDesde: (new Date()).addDays(-60),
            fechaHasta: new Date(),
            user: undefined,
            department: undefined,
            form: undefined,
        };
        _this.filterMeasurement={ company:undefined,asset:undefined,section:undefined};
        _this.user = Authentication.currentUserInfo();
        _this.isAdmin = Authentication.isAuthorized("admin");

        _this.users_ids = [_this.user.id].concat((_this.user.tags || []).flatMap(t => t.id))
        _this.Member = Member;
        _this.departments = departments
        const apiURL = require("../server").server;
        _this.forms = [];
        this.validations = []
        this.quickFilter = '';
        this.operatorList = [];
        this.departmentList = departments;
        this.formList = [];
        this.page = 1;
        this.recordLimit = 100;

        //SOLO PARA PAMPA CD
        this.assetsList = ["EMA", "SCH", "RDA", "CTA", "PNE", "TTY", "SCH SR"].sort((a, b) => a.localeCompare(b));
        this.companiesList = [];
        this.sectionsList = ["Operaciones", "Perforación", "Completación"].sort((a, b) => a.localeCompare(b));
        

        this.showOnlyCancel = false;
        // console.log('validation _this.departments', _this.departments)
        this.departmentSelection = () => {
             console.log('departmentSelection')
            _this.formList = [];
            _this.filter.form = undefined;
            if (_this.filter.department) {
                for (const f of _this.filter.department.forms) {
                    if(f.archived)
                        continue;
                    if (f.validate_required && f.validate_instances && f.validate_instances > 0
                        &&
                        (_this.shouldShowValidations() && ((this.isCertDigital && f.type == "measurement") || (!this.isCertDigital && f.type != "measurement") ))
                    ) {
                        // console.log(f.name, f.id, _this.filter.department?.name)
                        let validate_users = ((f.validate_users || []).flatMap(u => u.id)).concat((f.validate_defined || []).flatMap(inst => inst.validate_users.flatMap(u => u.id)))
                        if (validate_users.some(element => _this.users_ids.includes(element)) || validate_users.length == 0)
                            _this.formList.push(f);
                    }
                }
            };
        }

        _this.getFormById = function (formId) {
            return _this.forms.find(function (f) {
                return f.id === formId;
            }) || {};
        };
        _this.getDeptById = function (deptId) {
            return _this.departments.find(function (d) {
                return d.id === deptId;
            }) || {};
        };

        this.validationStateFilter = {};
        this.validationStateList = [];

        this.isValidationPending = (validation, form) => {
            const validate = validation.validate || [];
            if (validate.find(el => el.state === 'REJECT')) return false;
            const instances = form.validate_instances || 1;
            return validate.length < instances;
        };

        this.getValidationStateLabel = (validation, form) => {
            if (!form || !form.id) return '';
            const validate = validation.validate || [];
            const instances = form.validate_instances || 1;
            const type = form.validate_type || 'distinct';
            const validateDefined = form.validate_defined || [];
            const pendingText = $translate.instant('DASHBOARD.DASH_VALIDATIONS.STATES.PENDING');
            const userId = _this.user?.id;

            if (!this.isValidationPending(validation, form)) {
                const lastValidation = validate[validate.length - 1];
                if (!lastValidation) return '';
                if (lastValidation.state === 'OK') {
                    return $translate.instant('DASHBOARD.DASH_VALIDATIONS.STATES.OK');
                }
                if (lastValidation.state === 'REJECT') {
                    return $translate.instant('DASHBOARD.DASH_VALIDATIONS.STATES.REJECT');
                }
                const lastUserId = lastValidation.user?._id || lastValidation.user?.id;
                if (lastUserId === userId) {
                    return $translate.instant('DASHBOARD.DASH_VALIDATIONS.STATES.REJECT');
                }
                return lastValidation.state || '';
            }

            let pendingLabel = pendingText;
            if (instances > 1) {
                pendingLabel = pendingText.concat(' ', instances - validate.length);
            }
            if (type === 'instance-defined' && validate.length < validateDefined.length) {
                pendingLabel = validateDefined[validate.length]?.input || (pendingText + ' #' + (validate.length + 1));
                if (!_this.isAdmin && validate.length > 0) {
                    const usersArray = validateDefined[validate.length]?.validate_users || [];
                    const lastUserId = validate[validate.length - 1]?.user?._id;
                    if (lastUserId === userId &&
                        !usersArray.includes(userId) &&
                        !usersArray.some(u => u.id === userId) &&
                        !(_this.user.tags?.some(t => usersArray.map(u => u.id).includes(t.id)))) {
                        pendingLabel = 'Cancelar';
                    }
                }
            }
            return pendingLabel;
        };

        this.buildValidationStateOptions = () => {
            const states = new Set();

            _this.validations.forEach(validation => {
                const form = _this.getFormById(validation.formId);
                const label = _this.getValidationStateLabel(validation, form);
                if (label) states.add(label);
            });

            return Array.from(states).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
        };

        this.updateValidationStateList = () => {
            _this.validationStateList = _this.buildValidationStateOptions();
            Object.keys(_this.validationStateFilter).forEach(state => {
                if (!_this.validationStateList.includes(state)) {
                    delete _this.validationStateFilter[state];
                }
            });
        };

        this.hasActiveValidationStateFilter = () => {
            return Object.keys(_this.validationStateFilter).some(key => _this.validationStateFilter[key]);
        };

        this.toggleValidationStateFilter = (state, $event) => {
            if ($event) $event.stopPropagation();
            _this.validationStateFilter[state] = !_this.validationStateFilter[state];
            if (!_this.validationStateFilter[state]) {
                delete _this.validationStateFilter[state];
            }
        };

        this.clearValidationStateFilter = ($event) => {
            if ($event) $event.stopPropagation();
            _this.validationStateFilter = {};
        };

        this.validationStateFilterFn = (validation) => {
            if (!_this.hasActiveValidationStateFilter()) return true;
            const form = _this.getFormById(validation.formId);
            const label = _this.getValidationStateLabel(validation, form);
            return !!_this.validationStateFilter[label];
        };

        _this.loadUsersSubscribed = () => {
            let formIds = [];
            _this.forms?.forEach((form) => formIds.push(form.id));
            Form.UsersSubscribed(formIds)
                .$promise
                .then(function (response) {
                    //  console.log('Usuarios suscritos:', response);
                    if (Array.isArray(response.members)) {
                        _this.companiesList = [];
                        _this.operatorList = response.members.sort((a, b) => {
                            if (a.company) {
                                if (!_this.companiesList.some(c => c.externalId == a.company.externalId)) {
                                    _this.companiesList.push({
                                        externalId: a.company.externalId,
                                        value: "*".concat(a.company.externalId, "|", a.company.externalId, " - ", a.company.name),
                                        label: a.company.externalId.concat(" - ", a.company.name)
                                    });
                                }
                            } else {
                                console.log('El usuario no tiene asignada una empresa:', a.firstName, a.lastName, a.email);
                            }
                            const nameA = ((a.firstName || '') + ' ' + (a.lastName || '')).trim();
                            const nameB = ((b.firstName || '') + ' ' + (b.lastName || '')).trim();
                            return nameA.localeCompare(nameB);
                        });
                        _this.companiesList.sort((a, b) => a.label.localeCompare(b.label));
                    }
                    // console.log('_this.operatorList', _this.operatorList)
                })
                .catch(function (error) {
                    console.error('Error al obtener usuarios suscriptos:', error);
                });
        }

        _this.loadMoreRecords = () => {
            // console.log('load more records');
            _this.page = _this.page + 1;
            _this.loadValidations();
        }

        _this.loadValidations = function (init) {
            // console.log('loadValidations')

            if (_this.forms.length == 0)
                for (const dept of _this.departments) {
                    //NO SOY DUEÑO NI TEAMLEADER EN EL DEPTO -CONTINUE (SALTO)
                    const isOwner = _this.isAdmin || (dept.owners || []).some(o => o.id == _this.user.id); 
                    const isTeamLeader = (dept.teamLeaders || []).some(tl => tl.id == _this.user.id); // aca hay que ver si es teamleader de un equipo suscripto al formulario
                    
                    for (const f of dept.forms) {
                        if(f.archived)
                            continue;
                        // Para formularios NO measurement (otros tenants)
                        if (!_this.isCertDigital && f.validate_required && f.validate_instances && f.validate_instances > 0 && (_this.shouldShowValidations()  && f.type != "measurement")) {
                            // Verificar si está en validate_users (nivel formulario o instancias)
                            const validate_users = ((f.validate_users || []).flatMap(u => u.id)).concat((f.validate_defined || []).flatMap(inst => inst.validate_users.flatMap(u => u.id)))
                            const isInValidateUsers = validate_users.some(id => _this.users_ids.includes(id));

                            if ((isOwner && (f.validate_users || []).length == 0) || // Si no hay usuarios asignados, lo puede ver cualquiera
                                isInValidateUsers || // alguno de sus Ids esta en validate_users
                                isTeamLeader // o es isTeamLeader del departamento
                            ) {
                                _this.forms.push(f);
                            }
                        }

                        if (_this.isCertDigital && f.validate_required && f.validate_instances && f.validate_instances > 0 && (_this.shouldShowValidations() && f.type == "measurement")) {                            
                            if (f.validate_defined && f.validate_defined.length > 0 && f.validate_defined[0].validate_tagsMask && f.validate_defined[0].validate_tagsMask.length > 0)
                                _this.forms.push(f);
                            else {
                                let validate_users = ((f.validate_users || []).flatMap(u => u.id)).concat((f.validate_defined || []).flatMap(inst => inst.validate_users.flatMap(u => u.id)))
                                if (validate_users.some(element => _this.users_ids.includes(element)) || validate_users.length == 0) {
                                    _this.forms.push(f);
                                }
                            }
                        }
                    }
                }
            // console.log('this.forms', this.forms);

            try {
                let userPromise; // Needed for sync

                if (init) {
                    _this.operatorList = [];
                    _this.loadUsersSubscribed();

                    _this.user = Authentication.currentUserInfo();
                    userPromise = Promise.resolve(_this.user);
                } else {
                    userPromise = Authentication.resolveUser(true).then(function (response) {
                        _this.user = response;
                    });
                }
                userPromise.then(() => {
                    _this.users_ids = [_this.user.id].concat((_this.user.tags || []).flatMap(t => t.id));
                    
                    let formsToFilter = [];
                    if (_this.filter.department?.id) {
                        if (_this.filter.form) {
                            formsToFilter.push(_this.filter.form);
                        } else {
                            formsToFilter = _this.formList;
                        }
                    } else {
                        formsToFilter = _this.forms;
                    }
                    formsToFilter = formsToFilter.filter(f=>f.archived!=true);

                    const fechaDesde = _this.filter.fechaDesde;
                    fechaDesde.setHours(0, 0, 0, 0);
                    const fechaHasta = _this.filter.fechaHasta;
                    fechaHasta.setHours(23, 59, 59, 999);

                    if (!formsToFilter) {
                        console.log('ERROR GM001')
                    }

                    Member.ItemsPendingValidations({
                        userTags: _this.user.tags?.map(t => ({ id: t.id })),
                        memberId: _this.filter.user?.id,
                        forms: formsToFilter,
                        filterMeasurement: _this.filterMeasurement,
                        "minDate": fechaDesde.toISOString(),
                        "maxDate": fechaHasta.toISOString(),
                        // "minDate": (new Date(_this.filter.fechaDesde?.setHours(0, 0, 0, 0)))?.toISOString(),
                        // "maxDate": (new Date(_this.filter.fechaHasta?.setHours(23, 59, 59, 999)))?.toISOString(),
                        "rows": 100,
                        "page": _this.page
                    }).$promise
                    .then(function (response) {
                        _this.validations = [];
                        for (const item of response.items.data) {
                            const f = _this.getFormById(item.formId);
                            if (f.validate_type == "instance-defined") {
                                let shouldAdd = false;
                                const instanceNumber = item.validate.length;
                                if (f.validate_defined[instanceNumber].field && item.payload[f.validate_defined[instanceNumber].field]?.value) {
                                    let selected = item.payload[f.validate_defined[instanceNumber].field].value.split("|")[0];
                                    if (_this.users_ids.includes(selected)) {
                                        shouldAdd = true;
                                    }
                                } else if ((f.validate_defined[instanceNumber].field==null || f.validate_defined[instanceNumber].field=="") && ( f.validate_defined[instanceNumber].validate_users.length == 0 ||
                                    f.validate_defined[instanceNumber].validate_users.some(user => _this.users_ids.includes(user.id)))) {
                                    shouldAdd = true;
                                } else if (f.validate_defined[instanceNumber].validate_tagsMask?.length > 0) {
                                    const regex = /\$\{([^|}]+)(?:\|[^}]*)?\}/g;
                                    for (let mask of f.validate_defined[instanceNumber].validate_tagsMask) {
                                        mask = mask.replace(regex, (match, fieldId) => {
                                            console.log(`Hash encontrado: ${fieldId}`); // Puedes registrar el hash antes de reemplazarlo
                                            return (`${item.payload[fieldId]?.value?.split("|")[0]?.replace("*", "")}`); // Mantiene el formato `${}` con el nuevo valor                
                                        });
                                        let tag = _this.user.tags.find(t => t.name.includes(mask));
                                        if (tag) {
                                            shouldAdd = true;
                                            break;
                                        }
                                    }
                                } 
                                if (_this.showOnlyCancel && item.validate.length > 0 && item.validate[item.validate.length - 1].user._id == _this.user.id) {
                                    shouldAdd = true;
                                }
                                if (shouldAdd) {
                                    _this.validations.push(item);
                                }
                            } else {
                                _this.validations.push(item);
                            }
                        }
                        _this.updateValidationStateList();
                        // console.log('_this.operatorList', _this.operatorList);
                    });
                });
            } catch (e) {
                console.error(e);
                _this.validations = [];
                _this.updateValidationStateList();
            }
        }

        this.deleteItem = function(id) {
            // console.log('deleteItem en dashboard', id)
            _this.validations = _this.validations.filter(validation => validation.id !== id);
            _this.updateValidationStateList();
            // console.log('deleteItem _this.validations', _this.validations);
        }

        this.openFormData = (validation) => {
            // console.log('validation', validation);
            $state.go('dashboard.departments.department.forms.data', {
                departmentId: validation.deptId,
                formId: validation.formId
            });
        }

        this.sortField = 'date';
        this.sortDescending = true;

        this.setSort = function (field, descending) {
            this.sortField = field;
            this.sortDescending = descending;
        };

        this.dynamicSort = function () {
            return (validation) => {
                let form = this.getFormById(validation.formId);
                let value = '';
                switch (this.sortField) {
                    case 'date':
                        return new Date(validation._createdAt);
                    // case 'validate':
                    //     return validation.validate_lastUpdate ? validation.validate_lastUpdate : 0;
                    // case 'validationDate':
                    //     if (!validation.validate_lastUpdate) {
                    //         return 0; // Retorna 0 para registros sin fecha
                    //     }
                    //     return new Date(validation.validate_lastUpdate).getTime();
                    case 'validation':
                        // Para ordenamiento descendente: fechas sin valor van al final
                        // Para ordenamiento ascendente: fechas sin valor van al principio
                        if (!validation.validate_lastUpdate) {
                            return this.sortDescending ? 0 : Number.MAX_SAFE_INTEGER;
                        }
                        return new Date(validation.validate_lastUpdate).getTime();
                    case 'formName':
                        return form.name?.toLowerCase() || '';
                    case 'operator':
                        return (validation?.member?.firstName + ' ' + validation?.member?.lastName + ' ' + validation?.member?.email).toLowerCase();
                    case 'id':
                        return validation?.first_autonumeric || '';
                    case 'company':
                        return validation?.measuremen?.company ?
                            validation?.measurement?.company?.substr(validation?.measurement?.company?.indexOf("|") + 1)?.toLowerCase() : '';
                    case 'agreement':
                        return validation?.measurement?.agreement ?
                            validation?.measurement?.agreement?.substr(validation?.measurement?.agreement?.indexOf("|") + 1)?.toLowerCase() : '';
                    case 'asset':
                        return validation?.measurement?.asset ?
                            validation?.measurement?.asset?.substr(validation.measurement.asset.indexOf("|") + 1)?.toLowerCase() : '';
                    case 'section':
                        return validation?.measurement?.section ?
                            validation?.measurement?.section?.substr(validation?.measurement?.section?.indexOf("|") + 1)?.toLowerCase() : '';
                    default:
                        return '';
                }
            };
        };
        
        this.openGraphPanel = function () {
            $uibModal
                .open({
                    animation: true,
                    controller: ["$uibModalInstance", "Authentication", "Department", "Graph", "$sce", '$timeout', function ($uibModalInstance, Authentication, Department, Graph, $sce, $timeout) {
                        var _this = this;
                        // this.graphList = [];
                        this.graphURL = '';
                        this.currentGraphId = null;
                        localStorage.setItem("validationGraphHideNavBar", "1");
                        this.department = null;
                        this.deptIndex = null;
                        this.departmentList = [];
                        this.loadingDepartments = true;

                        Promise.all([
                            Graph.find().$promise,
                            Authentication.loadDepartments()
                        ])
                        .then(([graphs, departments]) => {
                            // console.log('graphs', graphs);
                            // console.log('departments', departments);
                        
                            if (departments && departments.length > 0) {
                                _this.departmentList = departments
                                    .map(department => {
                                        const departmentGraphs = graphs
                                            .filter(graph => graph.departmentId === department.id)
                                            .sort((a, b) => a.name.localeCompare(b.name));
                                        if (departmentGraphs.length > 0) {
                                            return {
                                                ...department,
                                                graphList: departmentGraphs
                                            };
                                        }
                                        return null;
                                    })
                                    .filter(department => department !== null)
                                    .sort((a, b) => a.name.localeCompare(b.name));
                                // console.log('_this.departmentList', _this.departmentList);

                                if (_this.departmentList.length > 0) {
                                    _this.selectDeptTab(0, 0);
                                } else {
                                    _this.department = null;
                                }
                            } else {
                                _this.departmentList = [];
                                _this.department = null;
                            }
                            $timeout(() => {
                                _this.loadingDepartments = false;
                            });
                        })
                        .catch(error => {
                            console.error("Error al cargar los departamentos y gráficos:", error);
                            _this.departmentList = [];
                            _this.department = null;
                            $timeout(() => {
                                _this.loadingDepartments = false;
                            });
                        });

                        this.selectDeptTab = (deptIndex, graphIndex) => {
                            // Clean iframe before changing
                            this.currentGraphId = null;
                            this.graphURL = '';
                            // console.log('index', deptIndex)
                            _this.departmentList = _this.departmentList.map((dept, index) => ({
                                ...dept,
                                selected: index === deptIndex,
                            }));
                            this.department = _this.departmentList[deptIndex];
                            this.deptIndex = deptIndex;
                            if (this.department.graphList.length > 0 && graphIndex !== undefined && graphIndex !== null) {
                                this.selectGraphTab(deptIndex, graphIndex);
                            }
                        }

                        this.selectGraphTab = (deptIndex, graphIndex) => {
                            // Clean iframe before changing
                            // ng-if destroys previuos iframe when currentGraphId is null
                            this.currentGraphId = null;
                            this.graphURL = '';
                            
                            $timeout(() => {
                                // console.log('graphIndex', graphIndex)

                                _this.departmentList[deptIndex].graphList =  _this.departmentList[deptIndex].graphList.map((graph, index) => ({
                                    ...graph,
                                    selected: index === graphIndex,
                                }));
                                this.getGraphUrl(_this.departmentList[deptIndex], graphIndex);
                            }, 150);
                        }
                        
                        this.getGraphUrl = function (dept, index) {
                            let element = dept.graphList[index];
                            // console.log('_this.graphList[index]', _this.graphList[index])
                            // console.log('element', element)

                            let fullUrl = window.location.href;
                            let baseUrl = fullUrl.split("/#")[0];
                            
                            // Force iframe reload by changing currentGraphId
                            this.currentGraphId = element.id;
                            
                            this.graphURL = $sce.trustAsResourceUrl("".concat(baseUrl, '/#/graph/', element.id, '?departmentId=',element.departmentId));
                            // console.log('this.graphURL', this.graphURL)
                            // console.log('url nueva', ("".concat(baseUrl, '/#/graph/', element.id, '?departmentId=',element.departmentId)))
                        }
                        // console.log('this.graphList', this.graphList)

                    },],
                    templateUrl: "dashboard-validations/dashboardValidationGraphModal.html",
                    controllerAs: "modal",
                    size: "xlg",
                    windowClass: "dialog",
                    bindToController: true,
                    resolve: {
                    },
                })
                .result.then((result) => {
                    delete localStorage.validationGraphHideNavBar;
                }, function() { //dismiss
                    delete localStorage.validationGraphHideNavBar;
                })
                .finally(() => {
                    delete localStorage.validationGraphHideNavBar;
                });
        };

        this.openFormPanel = function () {
            $uibModal
                .open({
                    animation: true,
                    controller: ["$uibModalInstance", "Authentication", "Department", "$sce", '$timeout', '$window', function ($uibModalInstance, Authentication, Department, $sce, $timeout, $window) {
                        var _this = this;
                        this.forms = [];
                        this.formURL = '';
                        this.formTableHasActiveFilters = false;
                        localStorage.setItem("validationFormHideNavBar", "1");
                        this.department = null;
                        this.deptIndex = null;
                        this.departmentList = [];
                        this.loadingDepartments = true;

                        const onDataGridFiltersMessage = function (event) {
                            if (!event.data || event.data.type !== 'dataGrid-filtersState') {
                                return;
                            }
                            const dept = _this.departmentList[_this.deptIndex];
                            const selectedForm = dept && dept.forms && dept.forms.find(function (f) { return f.selected; });
                            if (selectedForm && event.data.formId === selectedForm.id) {
                                _this.formTableHasActiveFilters = !!event.data.hasActiveFilters;
                                $timeout(function () { });
                            }
                        };
                        $window.addEventListener('message', onDataGridFiltersMessage);
                        const removeFiltersMessageListener = function () {
                            $window.removeEventListener('message', onDataGridFiltersMessage);
                        };
                        $uibModalInstance.result.then(removeFiltersMessageListener, removeFiltersMessageListener);

                        Authentication.loadDepartments()
                        .then(function (departments) {
                            // console.log('departments', departments);
                            if (departments && departments.length > 0) {
                                _this.departmentList = departments.map(department => {
                                    const departmentForms = department.forms.filter(f => f.archived != true).sort((a, b) => a.name.localeCompare(b.name));
                                    return {
                                        ...department,
                                        forms: departmentForms
                                    };
                                })
                                    .filter(department => department.forms && department.forms.length > 0)
                                    .sort((a, b) => a.name.localeCompare(b.name));
                                // console.log('_this.departmentList', _this.departmentList);
                            } else {
                                _this.departmentList = [];
                                _this.department = null;
                            }
                        })
                        .then(() => {
                            // console.log('_this.departmentList 2', _this.departmentList);
                            if (_this.departmentList.length > 0) {
                                _this.selectDeptTab(0, 0); // Seleccionamos el primer depto y primer form
                            } else {
                                _this.department = null;
                            }
                            $timeout(() => {
                                _this.loadingDepartments = false;
                            });
                        })
                        .catch(function (error) {
                            console.error("Error al cargar los departamentos:", error);
                            _this.departmentList = [];
                            _this.department = null;
                            $timeout(() => {
                                _this.loadingDepartments = false;
                            });
                        });

                        this.selectDeptTab = (deptIndex, formIndex) => {
                            this.formURL = '';
                            this.formTableHasActiveFilters = false;
                            // console.log('index', deptIndex)
                            _this.departmentList = _this.departmentList.map((dept, index) => ({
                                ...dept,
                                selected: index === deptIndex,
                            }));
                            this.department = _this.departmentList[deptIndex];
                            this.deptIndex = deptIndex;
                            if (this.department.forms.length > 0 && formIndex !== undefined && formIndex !== null) {
                                this.selectFormTab(deptIndex, formIndex);
                            }
                        }

                        this.selectFormTab = (deptIndex, formIndex, refresh = false) => {
                            this.formURL = '';
                            this.formTableHasActiveFilters = false;
                            // console.log('formIndex', formIndex)

                            _this.departmentList[deptIndex].forms =  _this.departmentList[deptIndex].forms.map((form, index) => ({
                                ...form,
                                selected: index === formIndex,
                            }));

                            if (!refresh) {
                                this.getFormUrl(_this.departmentList[deptIndex], formIndex);
                            }
                            else {
                                $timeout(() => {
                                    this.getFormUrl(_this.departmentList[deptIndex], formIndex);
                                }, 50)
                            }
                        }
                        
                        this.getFormUrl = function (dept, index) {
                            let element = dept.forms[index];                            
                            let fullUrl = window.location.href;
                            let baseUrl = fullUrl.split("/#")[0];

                            // let url =("".concat(baseUrl, '/#/app/dashboard/departments/', element.departmentId, '/forms/', element.id, '/data'));
                            this.formURL = $sce.trustAsResourceUrl("".concat(baseUrl, '/#/app/dashboard/departments/', element.departmentId, '/forms/', element.id, '/data'));
                            // console.log('this.formURL', this.formURL)
                        };

                        this.resetFormTableFilters = function ($event) {
                            if ($event) {
                                $event.stopPropagation();
                            }
                            try {
                                const iframe = document.getElementById('validationFormDataIframe');
                                if (!iframe || !iframe.contentWindow || !iframe.contentDocument) return;
                                const win = iframe.contentWindow;
                                const ng = win.angular;
                                if (!ng) return;
                                const injector = ng.element(win.document.body).injector();
                                if (injector) {
                                    injector.get('$rootScope').$broadcast('dataGrid-resetFilters');
                                }
                            } catch (e) {
                                console.error('Error al limpiar filtros de la tabla:', e);
                            }
                        };

                    },],
                    templateUrl: "dashboard-validations/dashboardValidationFormModal.html",
                    controllerAs: "modal",
                    size: "xlg",
                    windowClass: "dialog",
                    bindToController: true,
                    resolve: {
                    },
                })
                .result.then(function () {
                    delete localStorage.validationFormHideNavBar;
                }, function () {
                    delete localStorage.validationFormHideNavBar;
                });
        };

        this.openValidation = function (validation) {
            let url = apiURL + `/departments/${validation.deptId}/forms/${validation.formId}/html/${validation.id}`;
            window.open(url, "_blank");
        };

        // this.validate = function (validation) {
        //     console.log("Validar no implementado:", validation);
        // };

        // this.multiValidation = function () {
        //     console.log("Validacion multiple no implementado");
        // }
        if (this.departmentList && this.departmentList.length == 1){
            this.filter.department = this.departmentList[0]
            this.departmentSelection();
        }
        _this.loadValidations(true);
}];
